import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="glass-card border-t border-white/10 mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          <div>
            <h3 className="text-2xl font-bold gradient-text mb-4">AGOC 2026</h3>
            <p className="text-slate-300 text-sm leading-relaxed">
              All Gujarat Ophthalmic Society Annual Conference
            </p>
            <p className="text-slate-400 text-sm mt-2">
              October 24-25, 2026
            </p>
            <div className="mt-4 text-xs text-slate-400">
              <p>Organized by: AGOS</p>
              <p>Hosted by: SGAO</p>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-slate-300 hover:text-[#FF6F4A] transition-colors text-sm">
                  About AGOS
                </Link>
              </li>
              <li>
                <Link to="/program" className="text-slate-300 hover:text-[#FF6F4A] transition-colors text-sm">
                  Scientific Program
                </Link>
              </li>
              <li>
                <Link to="/faculty" className="text-slate-300 hover:text-[#FF6F4A] transition-colors text-sm">
                  Faculty
                </Link>
              </li>
              <li>
                <Link to="/registration" className="text-slate-300 hover:text-[#FF6F4A] transition-colors text-sm">
                  Registration
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-slate-300 text-sm">
                <MapPin className="h-4 w-4 mt-1 flex-shrink-0" />
                <span>Le Meridien<br/>(Old The Grand Bhagwati)<br/>Surat, Gujarat</span>
              </li>
              <li className="flex items-center gap-2 text-slate-300 text-sm">
                <Mail className="h-4 w-4 flex-shrink-0" />
                <a href="mailto:sgaosurat2025@gmail.com" className="hover:text-[#FF6F4A] transition-colors">
                  sgaosurat2025@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-slate-300 text-sm">
                <Phone className="h-4 w-4 flex-shrink-0" />
                <span>
                  <a href="tel:+919173797939" className="hover:text-[#FF6F4A] transition-colors">9173797939</a> | <a href="tel:+919898587360" className="hover:text-[#FF6F4A] transition-colors">9898587360</a>
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Follow Us</h4>
            <div className="flex gap-4">
              <a
                href="https://instagram.com/agocsurat2026"
                target="_blank"
                rel="noopener noreferrer"
                className="glass-card p-3 hover:bg-[#FF6F4A]/20 transition-all neon-glow"
                data-testid="instagram-link"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://www.facebook.com/people/AGOC-2026/61576205498964/"
                target="_blank"
                rel="noopener noreferrer"
                className="glass-card p-3 hover:bg-[#FF6F4A]/20 transition-all neon-glow"
                data-testid="facebook-link"
              >
                <Facebook className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="text-slate-400 text-sm">
            © 2026 All Gujarat Ophthalmic Society. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;